interface VisualSearchResultState {
  enableGrayScale?: boolean;
  imageLoaded: boolean;
  imageSrc: string;
  imageData: Uint8Array;
  luminanceSearch: boolean;
  useCropSearch: boolean;
  cropImageSrc: string;
  cropImageData: Uint8Array;
}

export default VisualSearchResultState;

export const initialState: VisualSearchResultState = {
  enableGrayScale: false,
  imageLoaded: false,
  imageSrc: '',
  imageData: null,
  luminanceSearch: true,
  useCropSearch: false,
  cropImageSrc: '',
  cropImageData: null,
};
